"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find");
var _asyncTask = require("@/api/job/asyncTask");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AsyncTaskManage',
  data: function data() {
    return {
      tableKey: 0,
      listLoading: false,
      taskList: [],
      total: 0,
      listQuery: {
        page: 1,
        size: 20,
        taskType: undefined,
        status: undefined,
        businessType: undefined,
        businessId: undefined
      },
      detailDialogVisible: false,
      currentTask: null,
      refreshInterval: null,
      // 任务类型配置
      taskTypeOptions: [{
        value: 'sync_menu',
        label: '同步菜单',
        tagType: 'primary'
      }, {
        value: 'goods_shelf_import',
        label: '商品上下架导入',
        tagType: 'primary'
      }, {
        value: 'dish_group_import',
        label: '菜单分组导入',
        tagType: 'primary'
      }],
      // 业务类型配置
      businessTypeOptions: [{
        value: 'menu_template',
        label: '菜单模板',
        tagType: 'success'
      }, {
        value: 'goods_shelf',
        label: '上下架',
        tagType: 'success'
      }, {
        value: 'dish_group',
        label: '菜单分组',
        tagType: 'success'
      }, {
        value: 'store',
        label: '门店',
        tagType: 'danger'
      }]
    };
  },
  computed: {
    // 获取任务类型配置
    getTaskTypeConfig: function getTaskTypeConfig() {
      var _this = this;
      return function (value) {
        return _this.taskTypeOptions.find(function (item) {
          return item.value === value;
        }) || {
          label: value,
          tagType: 'info'
        };
      };
    },
    // 获取业务类型配置
    getBusinessTypeConfig: function getBusinessTypeConfig() {
      var _this2 = this;
      return function (value) {
        return _this2.businessTypeOptions.find(function (item) {
          return item.value === value;
        }) || {
          label: value || '-',
          tagType: 'info'
        };
      };
    }
  },
  created: function created() {
    this.getList();
    // 每10秒自动刷新一次（用于更新执行中任务的进度）
    this.startAutoRefresh();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    // 查询任务列表
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, data, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.listLoading = true;
              _context.prev = 1;
              _context.next = 2;
              return (0, _asyncTask.getAsyncTaskList)(this.listQuery);
            case 2:
              response = _context.sent;
              if (response && (response.code === 0 || response.code === 200)) {
                // 适配不同的响应结构
                data = response.data || response.model || {};
                this.taskList = data.list || data.records || [];
                this.total = parseInt(data.total) || 0;
              } else {
                this.$message.error(response && response.msg ? response.msg : '查询失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error('查询任务列表失败：', _t);
              this.$message.error('查询任务列表失败');
            case 4:
              _context.prev = 4;
              this.listLoading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 搜索
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 重置筛选条件
    handleReset: function handleReset() {
      this.listQuery = {
        page: 1,
        size: 20,
        taskType: undefined,
        status: undefined,
        businessType: undefined,
        businessId: undefined
      };
      this.getList();
    },
    // 分页大小变化
    handleSizeChange: function handleSizeChange(size) {
      this.listQuery.size = size;
      this.listQuery.page = 1;
      this.getList();
    },
    // 当前页变化
    handleCurrentChange: function handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    // 取消任务
    handleCancelTask: function () {
      var _handleCancelTask = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(task) {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$confirm('确定要取消该任务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response, _t2;
                return regeneratorRuntime.wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 1;
                      return (0, _asyncTask.cancelTask)({
                        taskId: task.taskId || task.taskId
                      });
                    case 1:
                      response = _context2.sent;
                      if (!(response && (response.code === 0 || response.code === 200))) {
                        _context2.next = 3;
                        break;
                      }
                      _this3.$message.success('任务已取消');
                      _context2.next = 2;
                      return _this3.getList();
                    case 2:
                      _context2.next = 4;
                      break;
                    case 3:
                      _this3.$message.error(response && response.msg ? response.msg : '取消任务失败');
                    case 4:
                      _context2.next = 6;
                      break;
                    case 5:
                      _context2.prev = 5;
                      _t2 = _context2["catch"](0);
                      console.error('取消任务失败：', _t2);
                      _this3.$message.error('取消任务失败');
                    case 6:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[0, 5]]);
              })));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleCancelTask(_x) {
        return _handleCancelTask.apply(this, arguments);
      }
      return handleCancelTask;
    }(),
    // 重试任务
    handleRetryTask: function () {
      var _handleRetryTask = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(task) {
        var _this4 = this;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$confirm('确定要重试该任务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var response, _t3;
                return regeneratorRuntime.wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;
                      _context4.next = 1;
                      return (0, _asyncTask.retryTask)({
                        taskId: task.taskId || task.taskId
                      });
                    case 1:
                      response = _context4.sent;
                      if (!(response && (response.code === 0 || response.code === 200))) {
                        _context4.next = 3;
                        break;
                      }
                      _this4.$message.success('任务已重新提交');
                      _context4.next = 2;
                      return _this4.getList();
                    case 2:
                      _context4.next = 4;
                      break;
                    case 3:
                      _this4.$message.error(response && response.msg ? response.msg : '重试任务失败');
                    case 4:
                      _context4.next = 6;
                      break;
                    case 5:
                      _context4.prev = 5;
                      _t3 = _context4["catch"](0);
                      console.error('重试任务失败：', _t3);
                      _this4.$message.error('重试任务失败');
                    case 6:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[0, 5]]);
              })));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleRetryTask(_x2) {
        return _handleRetryTask.apply(this, arguments);
      }
      return handleRetryTask;
    }(),
    // 查看详情
    handleViewDetail: function handleViewDetail(task) {
      this.currentTask = task;
      this.detailDialogVisible = true;
    },
    // 格式化时间
    formatTime: function formatTime(ms) {
      if (!ms || ms <= 0) return '0秒';
      var seconds = Math.floor(ms / 1000);
      if (seconds < 60) {
        return "".concat(seconds, "\u79D2");
      }
      var minutes = Math.floor(seconds / 60);
      var remainingSeconds = seconds % 60;
      return "".concat(minutes, "\u5206").concat(remainingSeconds, "\u79D2");
    },
    // 格式化参数
    formatParams: function formatParams(params) {
      try {
        if (typeof params === 'string') {
          var parsed = JSON.parse(params);
          return JSON.stringify(parsed, null, 2);
        }
        return JSON.stringify(params, null, 2);
      } catch (e) {
        return params;
      }
    },
    // 开始自动刷新
    startAutoRefresh: function startAutoRefresh() {
      var _this5 = this;
      this.refreshInterval = setInterval(function () {
        // 只在有执行中的任务时才刷新
        var hasRunningTask = _this5.taskList.some(function (task) {
          return task.status === 'running';
        });
        if (hasRunningTask) {
          _this5.getList();
        }
      }, 10000); // 每10秒刷新一次
    },
    // 停止自动刷新
    stopAutoRefresh: function stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    }
  }
};